import { render, staticRenderFns } from "./LabDashboard.vue?vue&type=template&id=498965ab"
import script from "./LabDashboard.vue?vue&type=script&lang=js"
export * from "./LabDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports